import { render, staticRenderFns } from "./operations-awaiting-antifraud.vue?vue&type=template&id=854d373a"
import script from "./operations-awaiting-antifraud.vue?vue&type=script&lang=js"
export * from "./operations-awaiting-antifraud.vue?vue&type=script&lang=js"
import style0 from "./operations-awaiting-antifraud.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/payment-system/operations-awaiting-antifraud.vue
// module id = r2aE
// module chunks = 0